import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import {
 Control,
 Controller,
 FieldErrors,
 UseFormSetValue,
} from 'react-hook-form';

import SelectApi from '../../common/SelectApi';
import { WidgetProgressProps } from '../Dashboard.types';

interface DriversProgressFiltersProps {
 control: Control<WidgetProgressProps>;
 setValue: UseFormSetValue<WidgetProgressProps>;
 errors: FieldErrors<WidgetProgressProps>;
}

const DriversProgressFilters: React.FC<DriversProgressFiltersProps> = ({
 control,
 setValue,
 errors,
}) => {
 const customerFilter = JSON.stringify({ fields: 'Id,Name' });
 const driverFilter = JSON.stringify({ fields: 'Id,FullName' });

 return (
  <>
   <SelectApi<WidgetProgressProps>
    name="sender"
    url="/api/Customers/v2/"
    filter={customerFilter}
    label="Sender"
    isEditable
    operator="contains"
    control={control}
    setValue={setValue}
   />
   <SelectApi<WidgetProgressProps>
    name="receiver"
    url="/api/Customers/v2/"
    filter={customerFilter}
    label="Receiver"
    isEditable
    operator="contains"
    control={control}
    setValue={setValue}
   />
   <SelectApi<WidgetProgressProps>
    name="driver"
    url="/api/Drivers/v2/"
    filter={driverFilter}
    label="Driver"
    isEditable
    operator="contains"
    control={control}
    setValue={setValue}
   />
   <h3>Matavimo vienetai</h3>
   <FormControl fullWidth>
    <InputLabel id="sort-order-label">Sort Order</InputLabel>
    <Controller
     name="sortOrder"
     control={control}
     render={({ field }) => (
      <Select
       {...field}
       labelId="sort-order-label"
       id="sort-order"
       label="Sort Order"
       value={field.value || 'desc'}
      >
       <MenuItem value="desc">Descending</MenuItem>
       <MenuItem value="asc">Ascending</MenuItem>
      </Select>
     )}
    />
   </FormControl>
  </>
 );
};

export default DriversProgressFilters;
